import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import { usePageView } from '../../hooks/usePageView';
import './Pricing.css';

function Pricing() {
  usePageView('pricing');
  const { t } = useLanguage();
  const p = t.pricing;

  const internationalPricing = [
    { from: '深圳', to: '迪拜', price: '询价', time: '3-5天' },
    { from: '深圳', to: '阿布扎比', price: '询价', time: '3-5天' },
    { from: '深圳', to: '卡拉奇', price: '询价', time: '4-6天' },
    { from: '深圳', to: '孟买', price: '询价', time: '4-6天' },
    { from: '深圳', to: '新德里', price: '询价', time: '3-5天' },
    { from: '深圳', to: '钦奈', price: '询价', time: '4-6天' },
    { from: '深圳', to: '科伦坡', price: '询价', time: '4-6天' },
    { from: '深圳', to: '利雅得', price: '询价', time: '4-7天' },
  ];

  return (
    <div className="pricing-page">
      <Helmet>
        <title>运费价格 - 首嘉/深圳瀚阳</title>
        <meta
          name="description"
          content="查询首嘉/深圳瀚阳国内外货运参考价格，提供深圳至中东、南亚等地的空运报价。"
        />
        <meta property="og:title" content="运费价格 - 首嘉/深圳瀚阳" />
        <meta property="og:description" content="查询首嘉/深圳瀚阳国内外货运参考价格，提供深圳至中东、南亚等地的空运报价。" />
        <meta property="og:url" content="https://www.sz-showjoy.com/pricing" />
        <meta name="keywords" content="运费价格,物流报价,空运报价,深圳至迪拜,深圳至中东,深圳至南亚,国际运费" />
        <link rel="canonical" href="https://www.sz-showjoy.com/pricing" />
      </Helmet>
      <div className="page-header">
        <div className="container">
          <h1>{p.pageTitle}</h1>
          <p>{p.pageSubtitle}</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="pricing-notice">
            <h3>{p.noticeTitle}</h3>
            <ul>
              <li>{p.notice2}</li>
              <li>{p.notice3}</li>
              <li>{p.notice4}</li>
            </ul>
          </div>

          <div className="route-selector" style={{ display: 'none' }}>
            <button
              className="route-btn active"
            >
              {p.international}
            </button>
          </div>

          <div className="pricing-table" style={{ display: 'none' }}>
            <div className="table-header">
              <div>{p.origin}</div>
              <div>{p.destination}</div>
              <div>{p.refPrice}</div>
              <div>{p.estTime}</div>
            </div>
            {internationalPricing.map((route, index) => (
              <div key={index} className="table-row">
                <div className="table-cell">{route.from}</div>
                <div className="table-cell">{route.to}</div>
                <div className="table-cell price">
                  {route.price === '询价' ? route.price : `¥${route.price}/kg`}
                </div>
                <div className="table-cell">{route.time}</div>
              </div>
            ))}
          </div>

          <div className="pricing-calculator">
            <h3>{p.calcTitle}</h3>
            <p>{p.calcDesc}</p>
            <div className="calculator-form">
              <div className="form-row">
                <input type="text" placeholder={p.originPlaceholder} />
                <input type="text" placeholder={p.destPlaceholder} />
              </div>
              <div className="form-row">
                <input type="number" placeholder={p.weightPlaceholder} />
                <select>
                  <option>{p.goodsType}</option>
                  <option>{p.general}</option>
                  <option>{p.fragile}</option>
                  <option>{p.valuable}</option>
                  <option>{p.coldChain}</option>
                </select>
              </div>
              <button className="btn-primary calculate-btn">
                {p.calculate}
              </button>
            </div>
          </div>

          <div className="pricing-services">
            <h3>{p.extraServices}</h3>
            <div className="services-grid">
              <div className="service-item">
                <div className="service-icon">📦</div>
                <h4>{p.packaging}</h4>
                <p className="service-price">{p.packagingPrice}</p>
              </div>
              <div className="service-item">
                <div className="service-icon">🔒</div>
                <h4>{p.insurance}</h4>
                <p className="service-price">{p.insurancePrice}</p>
              </div>
              <div className="service-item">
                <div className="service-icon">📍</div>
                <h4>{p.pickup}</h4>
                <p className="service-price">{p.pickupPrice}</p>
              </div>
              <div className="service-item">
                <div className="service-icon">🏠</div>
                <h4>{p.delivery}</h4>
                <p className="service-price">{p.deliveryPrice}</p>
              </div>
            </div>
          </div>

          <div className="contact-cta">
            <h3>{p.customTitle}</h3>
            <p>{p.customDesc}</p>
            <div className="cta-buttons">
              <a href="tel:15521339259" className="btn-primary">
                {p.callNow}
              </a>
              <a href="/contact" className="btn-secondary">
                {p.onlineConsult}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Pricing;
